/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardStatView', ["$filter",
    function ($filter) {
        var LoyaltyCardStatView = function (loyaltyCard, parentCategoryStatView) {
            this.label = "";
            this.ca = 0;
            this.nbBookings = 0;
            this.parentCategoryStatView = parentCategoryStatView;
            this.loyaltyCardId = 0;

            this.loyaltyCardItems = [];  // [{dayId, loyaltyCardItemCard, price},...]

            if (loyaltyCard) {
                this.label = loyaltyCard.label;
                this.loyaltyCardId = loyaltyCard.id;
            }


        };

        return LoyaltyCardStatView;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/LoyaltyCardStatView.js